import createDate from './createDate';
import getFormattedDate from './getFormattedDate';
import parseStringTimestamp from './parseStringTimestamp';

export default (input: number | string): string => {
  return getFormattedDate(createDate(parseStringTimestamp(input)));
};
